















import {mixins}          from 'vue-class-component';
import {Component, Prop} from 'vue-property-decorator';
import MainMixin         from '@/mixins/Main';

@Component({
    name: `Alert`
})
export default class Alert extends mixins(MainMixin)
{
    @Prop({required: true, type: Number}) readonly id!: number;
    @Prop({required: true, type: String}) readonly html!: string;
    @Prop({required: true, type: Object}) readonly state!: string;

    public clickOn($event: MouseEvent): void
    {
        $event.preventDefault();
        $event.stopPropagation();
        this.$router.push(($event.target as HTMLElement).getAttribute(`href`) as string).catch((err) =>
        {
            console.error(err);
        });
    }

    public deleteClickOn(): void
    {
        this.$emit(`destroy`, this.id);
    }

    public lifetime: number = 1e4;

    public mounted(): void
    {
        setTimeout(() =>
        {
            this.$emit(`destroy`, this.id);
        }, this.lifetime / (1 + Number(this.$store.getters.touchscreen)));
    }
}
